import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { query, where, collection, getDocs } from "firebase/firestore";

const editGrading = async (user, updates, branchId) => {
  const db = getFirestore();
  const auth = getAuth();
  const currentUser = user || auth.currentUser;

  if (!currentUser) {
    throw new Error("User not authenticated");
  }

  try {
    const gradingQuery = query(
      collection(db, "grading"),
      where("branchId", "==", branchId)
    );
    const querySnapshot = await getDocs(gradingQuery);
    if (querySnapshot.empty) {
      throw new Error("No grading document found for this branchId");
    }
    // Assuming only one document per branchId
    const gradingRef = querySnapshot.docs[0].ref;
    await updateDoc(gradingRef, updates);
    return { success: true, message: "Grading updated successfully" };
  } catch (error) {
    console.error("Error updating grading:", error);
    throw { message: error.message, type: "error" };
  }
};

export default editGrading;
